import Actuator from './Actuator';
import Parseable from '@/models/Parseable';

export default class Revision extends Parseable {
    // Unique identifier for the revision
    id?: string;

    // Name of the revision (e.g., "Initial Version", "Update Q1 2024")
    title?: string;

    // Indicates whether this is the latest revision
    isLatest!: boolean;

    // Reference to the project ID this revision belongs to
    project!: string;

    // Reference to the previous revision ID (if any)
    previousVersion?: string;

    // Actuators linked to this revision (array of actuator IDs or objects)
    public actuators?: Actuator[] = [];

    // Tag for the revision, allowed values are "feet", "budget", "purchase"
    tag!: 'feet' | 'budget' | 'purchase';

    comment?: string;
    contactPerson?: string;
    creator?: string;

    public static parseFromObject(object: Partial<Revision>): Revision {
        const revision = new Revision();
        Object.assign(revision, object);
        if (object.actuators) {
            revision.actuators = Actuator.parseFromArray(object.actuators!);
        }
        return revision;
    }

    public static parseFromArray(array: Partial<Revision>[]): Revision[] {
        if (!Array.isArray(array)) {
            return [];
        }

        return array.map((obj) => Revision.parseFromObject(obj));
    }

    parseToObject(): any {
        return { ...this };
    }
}
